import React from "react";
import { useTranslation } from "react-i18next";

export type SubpageTitleProps = {
  titleJa: string;
  titleEn: string;
  /** 見出しに付与する id（任意・アンカー用） */
  id?: string;
  /** ページ主見出し。デフォルトは h2 */
  as?: "h1" | "h2";
};

const ZH_TITLE_MAP: Record<string, string> = {
  Company: "公司介绍",
  company: "公司介绍",
  service: "服务范围",
  Services: "服务范围",
  development: "开发案例",
  Projects: "开发案例",
  Research: "研究事业",
  scientific_career: "研究事业",
  faq: "常见问题",
  FAQ: "常见问题",
  Recruit: "招聘信息",
  Careers: "招聘信息",
  News: "新闻动态",
  contact: "联系我们",
  Contact: "联系我们",
  Business: "业务内容",
  business: "业务内容",
  column: "专栏文章",
  Column: "专栏文章",
};

const SubpageTitle: React.FC<SubpageTitleProps> = ({
  titleJa,
  titleEn,
  id,
  as: HeadingTag = "h2",
}) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "ja").split("-")[0];

  let mainTitle = titleJa;
  let subTitle = titleEn;

  if (lang === "en") {
    mainTitle = titleEn.toUpperCase();
    subTitle = titleJa;
  } else if (lang === "zh") {
    mainTitle = ZH_TITLE_MAP[titleEn] || ZH_TITLE_MAP[titleJa] || titleJa;
    subTitle = titleEn;
  }

  return (
    <header className="subpage-title">
      <HeadingTag id={id} className="subpage-title-ja">
        {mainTitle}
      </HeadingTag>
      <p className="subpage-title-en">{subTitle}</p>
    </header>
  );
};

export default SubpageTitle;
